export default __webpack_public_path__ + "static/media/dashboard-1.04b5478e.png";